import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const schema = Yup.object().shape({
  address: Yup.string().required(FORM_VALIDATION_ERRORS.streetOne),
  addressTwo: Yup.string().nullable(),
  zipCode: capsuleValidation.zip().required(FORM_VALIDATION_ERRORS.zip),
  instructions: Yup.string().nullable(),
  isDoorman: Yup.boolean().required(FORM_VALIDATION_ERRORS.doorman),
});

const validation = {
  schema,
};

export default validation;
